import { render } from "./TestManagerialPotential.vue?vue&type=template&id=54097e68&scoped=true"
import script from "./TestManagerialPotential.vue?vue&type=script&lang=js"
export * from "./TestManagerialPotential.vue?vue&type=script&lang=js"

import "./TestManagerialPotential.vue?vue&type=style&index=0&id=54097e68&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54097e68"]])

export default __exports__